<template>
    <PromotionsContainer
        groupName="bonuses-promotions"
    />
</template>

<script>

    import PromotionsContainer from '@app/promotions/components/PromotionsContainer';

    export default {
        name: 'PromotionsInfoPage',
        components: {
            PromotionsContainer,
        },
    };
</script>
